import { render, staticRenderFns } from "./Cartao.vue?vue&type=template&id=2990d7ca&"
import script from "./Cartao.vue?vue&type=script&lang=js&"
export * from "./Cartao.vue?vue&type=script&lang=js&"
import style0 from "./Cartao.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports